import { type State } from 'app/common/ui-components/filter'

import { flags as group } from '../group'
import { flags as groupComplexesSpecial } from '../groupComplexesSpecial'
import { flags as period } from '../period'

const expandSubsidiesActivity = (state: State) => {
  return (
    (period.finalDateInCurrentMonth(state) && group.filterActive(state) &&
      (group.byGroupComplexesSelected(state) || group.byCampComplexesSelected(state))) ||
    (period.finalDateInCurrentMonth(state) && groupComplexesSpecial.filterActive(state) &&
      (groupComplexesSpecial.byGroupComplexesSpecialSelected(state) ||
        groupComplexesSpecial.byCampComplexesSpecialSelected(state)))
  )
}

export default expandSubsidiesActivity
